// update state
const setActiondropdownFlag = (payload) => {
    return {
        type: "DROPDOWNFLAG",
        payload
    }
}

export default setActiondropdownFlag;


// WEBPACK FOOTER //
// ./src/actions/setActiondropdownFlag.js